const productionConfig = {
  seoPartUrl: "https://onlinezdrav.ru",

  api: {
    tokenKey: "access_token",
    tokenValue: "D55C9523-6D68-5E04-E053-0100007F375E",
    endpoints: {
      vrach: "https://api.goodline.info/ords/mobile/digitalcity/v6/mo",
      egis: "https://api.goodline.info/ords/mobile/mo-egis/v1",
      onlinezdrav: "https://onlinezdrav.ru/api/v1",
    },
  },

  sentryUrl: "https://77050d7a80064992a2baec1c57b09cdb@sentry.eltc.ru/162",
  yandexGeocoderApiKey: "b743d7b3-e9d9-4cf2-8126-3aa7127d5e46",
  amplitudeApiKey: "82c88be1027dd000a09d5d73bd45fa15",
};

const stageConfig = {
  ...productionConfig,
  seoPartUrl: "https://onlinezdrav-test.eltc.ru",
  api: {
    ...productionConfig.api,
    endpoints: {
      vrach: "https://api.goodline.info/dev/mobile/digitalcity/v6/mo",
      egis: "https://api.goodline.info/dev/mobile/mo-egis/v1",
      onlinezdrav: "https://onlinezdrav-test.eltc.ru/api/v1",
    },
  },
};

export default window.location.host === "app.onlinezdrav.ru"
  ? productionConfig
  : stageConfig;

// export default productionConfig;
